<template>
  <div class="commerce-agent-order-weight-panel">
    <button class="delete is-large is-pulled-right" @click="close" />
    <p class="subtitle">Edit Weight</p>

    <p class="subtitle has-text-white has-text-weight-medium">
      {{ o.quantity }} x {{ o.item.name }}
    </p>

    <div class="wrapper">
      <p>
        Price {{ currency }}{{ o.item.price
        }}{{ translateByWeight(o.item.by_weight) }}
      </p>

      <p>
        <i class="fa fa-weight fa-sm" />&nbsp;~{{ o.item.estimated_weight }}
        grams per piece (on menu)
      </p>
      <p class="has-text-weight-bold">
        <i class="fa fa-weight fa-sm" />&nbsp;{{
          actualWeightPerPiece || "???"
        }}
        grams per piece (weighed)
      </p>

      <div class="field has-addons" style="margin-top: 10px">
        <div class="control">
          <a class="button is-medium is-light has-text-grey"
            >Est Total Weight</a
          >
        </div>
        <div class="control is-expanded">
          <input
            class="input is-grey has-text-grey is-medium"
            readonly
            :value="o.item.estimated_weight * o.quantity + ' grams'"
          />
        </div>
      </div>

      <div class="field has-addons" style="margin-top: 10px">
        <div class="control">
          <a class="button is-medium is-light">Actual Total Weight</a>
        </div>
        <div class="control is-expanded">
          <input
            class="input is-success is-medium"
            type="number"
            v-model="actualTotalWeight"
            placeholder="Grams"
            @keydown="edited = true"
          />
        </div>
      </div>

      <p>Enter total weight rounded to closest gram</p>

      <p>
        <span
          class="button is-success is-fullwidth is-medium"
          @click="updateWeight"
          >Update Weight</span
        >
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "CommerceAgentOrderWeightPanel",
  props: {
    o: Object,
    currency: String,
  },
  data() {
    return {
      actualTotalWeight: null,
    };
  },
  computed: {
    actualWeightPerPiece() {
      return Math.round(this.actualTotalWeight / this.o.quantity);
    },
  },
  mounted() {
    if (this.o.weighed) {
      this.actualTotalWeight = this.o.item.actual_weight * this.o.quantity;
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    updateWeight() {
      if (!this.actualTotalWeight) {
        this.errorToast("Invalid weight<br>Enter a number >0", "top");
        return;
      }
      // this.infoToast("Actual total weight: " + this.actualTotalWeight);
      // var weightPerPiece = Math.round(this.actualTotalWeight / this.o.quantity);
      this.$emit("editWeight", this.actualWeightPerPiece);
      this.close();
    },
    changeState(state) {
      var loader = this.loadingDots("pink");
      var payload = { id: this.t.id, state: state };
      this.$store
        .dispatch("forceChangeTransactionState", payload)
        .then((res) => {
          console.log("forceChangeTransactionState", res.data);
          this.successToast("Changed state to " + state);
          this.$emit("update");
          this.close();
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
  },
};
</script>

<style scoped>
.commerce-agent-order-weight-panel {
  z-index: 3;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100vw;
  padding: 10px;
  background-color: #1f1b24;
  color: white;
  padding-bottom: 30px;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  box-shadow: 0 0 4px 4px white;
}
.subtitle {
  margin-top: 5px;
  margin-bottom: 16px;
  color: #ccc;
}
.wrapper p {
  padding: 10px 0;
}
</style>